import FlatDetails from './lib/FlatDetails/FlatDetails';
import FlatsTable from './lib/FlatsTable/FlatsTable';
import FlatsTableHeading from './lib/FlatsTable/lib/FlatsTableHeading/FlatsTableHeading';
import { useFlatsDataContext } from '../../contexts/FlatsDataContext';
import { paths } from '../../settings';

import styles from './FlatSidebar.module.css';

const FlatsSidebar: React.FC = (): JSX.Element => {
    const { contextFlats, contextSelectedFlat, contextShowSidebar, contextSelectedFloor, setContextSetShowSidebar } = useFlatsDataContext();

    return (
        (contextShowSidebar || contextSelectedFloor) 
        ? (
            <div data-selected-floor={contextSelectedFloor ? '' : undefined}>
                {contextSelectedFlat.name !== '' && <FlatDetails flat={contextSelectedFlat} />}
                <div className={`${styles.wrapper} ${contextSelectedFlat.name !== '' ? styles.hidden : ''}`}>
                    {contextSelectedFlat.name === '' && (
                        <div className={styles.closeButton} onClick={() => setContextSetShowSidebar(false)}>
                            <img src={`${paths.assets}/icons/close.png`} width={24} height={24} alt="Zamknij" />
                        </div>
                    )}
                    <FlatsTableHeading totalFlats={contextFlats.length} />
                    <FlatsTable flats={contextFlats} />
                </div>
            </div>
        ) : <></>
    );
};

export default FlatsSidebar;